export type TranscriptChange = { kind: 'same' | 'removed' | 'added'; text: string }

/** Preserve both transcripts exactly; bound the work for unusually long revisions. */
export function diffTranscript(original: string, edited: string): TranscriptChange[] {
  const left = original.match(/\s+|\S+/gu) || [], right = edited.match(/\s+|\S+/gu) || []
  let prefix = 0, suffix = 0
  while (prefix < left.length && prefix < right.length && left[prefix] === right[prefix]) prefix++
  while (suffix < left.length - prefix && suffix < right.length - prefix && left[left.length - 1 - suffix] === right[right.length - 1 - suffix]) suffix++
  const a = left.slice(prefix, left.length - suffix), b = right.slice(prefix, right.length - suffix)
  const parts: TranscriptChange[] = []
  function add(kind: TranscriptChange['kind'], text: string) {
    if (!text) return
    const last = parts[parts.length - 1]
    if (last?.kind === kind) last.text += text
    else parts.push({ kind, text })
  }
  add('same', left.slice(0, prefix).join(''))
  if ((a.length + 1) * (b.length + 1) > 1_000_000) {
    // A whole changed block remains a truthful diff without quadratic UI work.
    add('removed', a.join('')); add('added', b.join(''))
  } else {
    const width = b.length + 1
    const matches = new Uint32Array((a.length + 1) * width)
    for (let i = a.length - 1; i >= 0; i--) for (let j = b.length - 1; j >= 0; j--) {
      matches[i * width + j] = a[i] === b[j] ? 1 + matches[(i + 1) * width + j + 1] : Math.max(matches[(i + 1) * width + j], matches[i * width + j + 1])
    }
    let i = 0, j = 0
    while (i < a.length || j < b.length) {
      if (i < a.length && j < b.length && a[i] === b[j]) { add('same', a[i]); i++; j++ }
      else if (i < a.length && (j === b.length || matches[(i + 1) * width + j] >= matches[i * width + j + 1])) add('removed', a[i++])
      else add('added', b[j++])
    }
  }
  add('same', suffix ? left.slice(-suffix).join('') : '')
  return parts
}
